const DEFAULT_CLASSNAMES = {
  td: "w-full",
  select: "w-full font-ubuntuRegular shadow h-[36px] text-center p-1 rounded",
};

const TableSelectionInput = ({
  classNames = DEFAULT_CLASSNAMES,
  value = "",
  options = [],
  ...otherProps
}) => {
  return (
    <td className={classNames.td}>
      <select value={value || ""} {...otherProps} className={classNames.select}>
        <option disabled={true} value="" className="hidden"></option>
        {options?.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </td>
  );
};

export default TableSelectionInput;
